import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { AuthRoleGuard } from './modules/shared/components/auth/auth-role.guard';
import { HomeComponent } from './modules/app/pages/home/home.component';
import { AuthGuard } from './modules/shared/components/auth/auth.guard';
import { NotAuthorizedComponent } from './modules/shared/pages/not-authorized-compoment';
import {  RequisitionTutorialBlades } from '@framework/components/mf-blade-forms/MfBladeFormsExt';
import { Permissions } from './config/AppEnums';

const routes: Routes = [

  {
    path: '', component: HomeComponent, pathMatch: 'full',
    canActivate: [AuthGuard]
  },
  {
    path: 'callback', redirectTo: ''
  },
  {
    path: 'tutorial',
    component: RequisitionTutorialBlades
  },
  {
    path: 'hr',
    loadChildren: './modules/hr/hr.module#HRModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.OrganisationList, Permissions.OrganisationView, Permissions.OrganisationManage, Permissions.OrganisationRolesManage, Permissions.UserAdvancedView,
      Permissions.UserAdvancedManage]
    }
  },
  {
    path: 'import',
    loadChildren: './modules/import/import.module#ImportModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.ImportsModule]
    }
  }, {
    path: 'stock',
    loadChildren: './modules/stock/stock.module#StockModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.StockItemsModule, Permissions.StockItemsModuleEdit, Permissions.StockItemsModuleView, Permissions.SupplierEdit, Permissions.SupplierManageDocuments]
    }
  }, {
    path: 'dashboard',
    loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.DashboardModule]
    }
  },
  {
    path: 'requisition',
    loadChildren: './modules/requisition/requisition.module#RequisitionModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.RequisitionCreate,
        Permissions.ProcurementApproval,
        Permissions.RequisitionApproval,
        Permissions.StockRequisition, Permissions.RequisitionJobManagement]
    }
  },
  {
    path: 'reqdashboard',
    loadChildren: './modules/req-dashboard/req-dashboard.module#ReqDashboardModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [
        Permissions.ProcurementApproval]
    }
  },
  {
    path: 'reqreports',
    loadChildren: './modules/req-reports/req-reports.module#ReqReportsModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [
        Permissions.ProcurementApproval, Permissions.OutstandingItemsReport, Permissions.RequisitionCreate, Permissions.StockRequisition]
    }
  },
  {
    path: 'ims',
    loadChildren: './modules/ims/ims.module#ImsModule',
    canActivate: [AuthRoleGuard],
    data: {
      expectedPermissions: [Permissions.ImsModule, Permissions.EMSManage, Permissions.EMSView]
    }
  },
  {
    path: 'party',
    loadChildren: './modules/party/party.module#PartyModule',
    canActivate: [AuthGuard],
  }, 
  {
    path: 'invoicing',
    loadChildren: './modules/invoicing/invoicing.module#InvoicingModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'jse',
    loadChildren: './modules/jse/jse.module#JSEModule',
    canActivate: [AuthGuard],
	},
	{
		path: 'detailedwip',
		loadChildren: './modules/detailed-wipreport/detailed-wipreport.module#DetailedWipreportModule',
		canActivate: [AuthGuard],
	},
  { path: 'unauthorised', component: NotAuthorizedComponent },
  {
    path: '**',
    redirectTo: 'login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(
    routes,
    { enableTracing: false } // <-- debugging purposes only
  )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
